module.exports = __webpack_public_path__ + "img/schnittkante_weiss-transluzent.8a82bb21.jpg";